interface AsyncFun<R> {
    (...args): Promise<R>;
}

const justLast = <R extends any, T extends AsyncFun<R>>(fun: T, tokenRef?: { current?: Symbol }): T => {
    const tokenReference = tokenRef ?? { current: Symbol() };
    return ((...args) => {
        const token = Symbol();
        tokenReference.current = token;

        return fun(...args)
            .then((value) => {
                if (token !== tokenReference.current) {
                    return new Promise(() => void 0);
                }
                return value;
            })
            .catch((e) => {
                if (token !== tokenReference.current) {
                    return new Promise(() => void 0);
                }
                throw e;
            });
    }) as T;
};

const justPending = <R extends any, T extends AsyncFun<R>>(fun: T, ref?: { current?: null }): T => {
    const pendingRef: any = ref ?? { current: null };
    return ((...args) => {
        if (pendingRef.current) {
            return pendingRef.current;
        }

        pendingRef.current = fun(...args)
            .finally(() => {
                pendingRef.current = null;
            });
        return pendingRef.current;
    }) as T;
};

export { justLast, justPending };
export type { AsyncFun };

